import React from "react";
import JenisIuranMenu from "../components/menu/admin/JenisIuranMenu"

const JenisIuran = () => {
  return <JenisIuranMenu />;
};

export default JenisIuran;
